module.exports = __webpack_public_path__ + "img/52002739_L.2fee039f.png";